import React, { useState, useEffect } from 'react';
import {
  AppBar, Toolbar, Typography, Box, Button, Container,
  IconButton, Select, MenuItem,
  useMediaQuery, useTheme, List, ListItem, ListItemText
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouse, faUser, faPhone, faTag, faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import logo from '../assets/logo-removebg-preview.png';

import hamburgerlogo from '../assets/hamburgerlogo.png';
import { useNavigate } from 'react-router-dom';
import { getalllocations } from '../services/apiService';
import { faPlus, faMinus } from '@fortawesome/free-solid-svg-icons';
import { Collapse, Drawer, ListItemIcon, ListItemButton } from '@mui/material';
import Divider from '@mui/material/Divider';
import { faFacebookF, faTwitter, faInstagram, faYoutube } from '@fortawesome/free-brands-svg-icons';


const Navbar = () => {
  const theme = useTheme();


  const navigate = useNavigate();
  const [menuModalOpen, setMenuModalOpen] = useState(false);
  const [rightDrawerOpen, setRightDrawerOpen] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));


  const toggleRightDrawer = (open) => (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    setRightDrawerOpen(open);
  };

 const handleMenuModalToggle = () => {
  // ✅ Blur active element before closing the drawer
  if (menuModalOpen && document.activeElement) {
    document.activeElement.blur();
  }
  setMenuModalOpen(!menuModalOpen);
};

  const [allLocations, setAllLocations] = useState({});
  const [locationCities, setLocationCities] = useState([]);
  const [selectedCity, setSelectedCity] = useState('');
  useEffect(() => {
    const fetchLocations = async () => {
      const response = await getalllocations();
      // If response is { locations: { Hyderabad: [...] } }
      const cities = response.locations ? Object.keys(response.locations) : Object.keys(response);
      const locationsObj = response.locations || response;
      setAllLocations(locationsObj);
      setLocationCities(cities);
      setSelectedCity(cities[0] || '');
    };
    fetchLocations();
  }, []);

  const modalData = {
    locations: [
      "Change Location",
      "Hyderabad",  
    ],
    sections: [
      {
        id: "hyd",
        title: "Properties in Hyderabad",
        items: allLocations,
        
        
      },
      {
        id: "builders",
        title: "Top Builders",
        items: [
          { name: "Prestige", path: "" },
          { name: "Lodha", path: "" },
          { name: "Brigade", path: "" },
          { name: "Godrej", path: "" }
        ]
      },
      {
        id: "projects",
        title: "Popular Projects",
        items: [
          { name: "Prestige High Fields", path: "" },
          { name: "Lodha Meridian", path: "" },
          { name: "Brigade at No.7", path: "" },
          { name: "Godrej Oasis", path: "" }
        ]
      },
      {
        id: "guide",
        title: "Property Guide",
        items: [
          { name: "Builder Partners", path: "/builder-partners" },
          { name: "Docs Required for Home Loan", path: "/docs-required" },
          { name: "EMI Calculator", path: "/emi-calculator" },
          { name: "Faq", path: "/faqs" },
          { name: "Home Loan", path: "/home-loan" },
          { name: "Property Buying Steps", path: "/property-buying-steps" },
          { name: "Vaastu Tips", path: "/vaastu-tips" },
        ]
      },


    ],
    contact: {
      phone: "+91 970 540 1575"
    },
    socialIcons: [
      { name: 'facebook-f', component: faFacebookF },
      { name: 'twitter', component: faTwitter },
      { name: 'instagram', component: faInstagram },
      { name: 'youtube', component: faYoutube }
    ]
  };

  const navItems = [
    { text: 'Home', icon: faHouse, path: '/' },
    { text: 'About Us', icon: faUser, path: '/aboutus' },
    { text: 'Contact Us', icon: faPhone, path: '/contactus' },
    { text: 'Offers', icon: faTag, path: '/propertylist' }
  ];

  const rightDrawer = (
    <Box
      sx={{ width: 250 }}
      role="presentation"
      onClick={toggleRightDrawer(false)}
      onKeyDown={toggleRightDrawer(false)}
    >
      <List>
        {navItems.map((item) => (
          <ListItemButton key={item.text} onClick={() => navigate(item.path)} >
            <ListItemIcon>
              <FontAwesomeIcon icon={item.icon} style={{ color: '#d10000' }} />
            </ListItemIcon>
            <ListItemText sx={{ py: 1.5 , fontWeight: 600 }} primary={item.text} />
          </ListItemButton>
        ))}
      </List>
      <Divider />
      <Box sx={{ p: 2, textAlign: 'center' }}>
        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
          Follow Us
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 1 }}>
          <IconButton size="small">
            <FontAwesomeIcon icon={faFacebookF} style={{ color: '#1877f2' }} />
          </IconButton>
          <IconButton size="small">
            <FontAwesomeIcon icon={faTwitter} style={{ color: '#1da1f2' }} />
          </IconButton>
          <IconButton size="small">
            <FontAwesomeIcon icon={faInstagram} style={{ color: '#e4405f' }} />
          </IconButton>
          <IconButton size="small">
            <FontAwesomeIcon icon={faYoutube} style={{ color: '#ff0000' }} />
          </IconButton>
        </Box>
      </Box>
    </Box>
  );

  const [openDropdowns, setOpenDropdowns] = useState({
    hyd: false,
    builders: false,
    projects: false,
    guide: false,
  });

  const handleDropdownToggle = (key) => {
    setOpenDropdowns((prev) => {
      // Close all dropdowns first
      const newState = Object.keys(prev).reduce((acc, k) => {
        acc[k] = false;
        return acc;
      }, {});

      
      // Toggle the clicked dropdown
      newState[key] = !prev[key];
      return newState;

    });
  };

  // Left Side Menu Drawer
  const menuDrawer = (
    <Box sx={{ width: 320, bgcolor: '#fff', height: '100vh', boxShadow: 3, p: 2, display: 'flex', flexDirection: 'column', }}>
      {/* Close Button */}
      <IconButton onClick={handleMenuModalToggle} sx={{ alignSelf: 'flex-end', mb: 1, '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.04)' } }}>
        <FontAwesomeIcon icon={faTimes} style={{ color: '#666' }} />
      </IconButton>
      {/* Location Dropdown */}
      <Select
        fullWidth
        size="small"
        value={selectedCity}
        onChange={e => setSelectedCity(e.target.value)}
        sx={{ mb: 2, cursor: 'pointer' }}
        MenuProps={{
          disableScrollLock: true,
          PaperProps: {
            style: {
              maxHeight: 300,
              zIndex: 9999
            }
          },
          MenuListProps: {
            'aria-labelledby': 'location-select-label'
          }
        }}
        inputProps={{
          'aria-label': 'Select city',
          id: 'location-select'
        }}
      >
        {locationCities.map((city) => (
          <MenuItem key={city} value={city}>{city}</MenuItem>
        ))}
      </Select>

      

      {/* Dynamic Sections */}
      <List disablePadding sx={{ mb: 2 }}>
        {/* Dynamic City/Location Section */}
        {selectedCity && (
          <div key={selectedCity}>
            <ListItem 
              component="div"
              onClick={() => handleDropdownToggle(selectedCity)} 
              sx={{ 
                py: 1, 
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: 'rgba(0, 0, 0, 0.04)'
                }
              }}
            >
              <ListItemText primary={<span style={{ fontWeight: 600, color: '#222' }}>{`Properties in ${selectedCity}`}</span>} />
              <FontAwesomeIcon icon={openDropdowns[selectedCity] ? faMinus : faPlus} />
            </ListItem>
            <Collapse in={openDropdowns[selectedCity]} timeout="auto" unmountOnExit>
              <List disablePadding>
                {(allLocations[selectedCity] || []).map((location) => (
                  <ListItem
                    key={location}
                    component="div"
                    sx={{
                      pl: 4, 
                      py: 0.5,
                      cursor: 'pointer',
                      '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)'
                      }
                    }}
                    onClick={() => {
                      setMenuModalOpen(false);
                      // Navigate to the property list with the selected location
                      const searchParams = new URLSearchParams(window.location.search);
                      
                      if (location && location.toLowerCase() !== 'all') {
                        searchParams.set('location', location);
                      } else {
                        searchParams.delete('location');
                      }
                      
                      navigate({
                        pathname: '/propertylist',
                        search: searchParams.toString(),
                        state: { location: location || '' },
                        replace: true
                      });
                    }}
                  >
                    <ListItemText
                      primary={location}
                      primaryTypographyProps={{ fontSize: 14 }}
                    />
                  </ListItem>
                ))}
              </List>
            </Collapse>
            <Divider />
          </div>
        )}

        {/* Static Dummy Sections */}
        {[
          {
            id: "builders",
            title: "Top Builders",
            items: [
              { name: "Prestige", path: "" },
              { name: "Lodha", path: "" },
              { name: "Brigade", path: "" },
              { name: "Godrej", path: "" }
            ]
          },
          {
            id: "projects",
            title: "Popular Projects",
            items: [
              { name: "Prestige High Fields", path: "" },
              { name: "Lodha Meridian", path: "" },
              { name: "Brigade at No.7", path: "" },
              { name: "Godrej Oasis", path: "" }
            ]
          },
          {
            id: "guide",
            title: "Property Guide",
            items: [
              { name: "Builder Partners", path: "/builder-partners" },
              { name: "Docs Required for Home Loan", path: "/docs-required" },
              { name: "EMI Calculator", path: "/emi-calculator" },
              { name: "Faq", path: "/faqs" },
              { name: "Home Loan", path: "/home-loan" },
              { name: "Property Buying Steps", path: "/property-buying-steps" },
              { name: "Vaastu Tips", path: "/vaastu-tips" },
            ]
          },
          {
            id: "home-loan-facility",
            title: "Home Loan Facility",
            path: "/home-loan-facility",
            isLink: true
          },
          {
            id: "interior-design",
            title: "Interior Design",
            path: "/interior-design",
            isLink: true
          }
        ].map((section) => (
          <div key={section.id}>
            {section.isLink ? (
              <>
                <ListItem 
                  component="div"
                  onClick={() => {
                    setMenuModalOpen(false);
                    navigate(section.path);
                  }} 
                  sx={{ 
                    py: 1, 
                    cursor: 'pointer',
                    '&:hover': {
                      backgroundColor: 'rgba(0, 0, 0, 0.04)'
                    }
                  }}
                >
                  <ListItemText 
                    primary={<span style={{ fontWeight: 600, color: '#222' }}>{section.title}</span>} 
                  />
                </ListItem>
                <Divider />
              </>
            ) : (
              <>
                <ListItem 
                  component="div"
                  onClick={() => handleDropdownToggle(section.id)} 
                  sx={{ 
                    py: 1, 
                    cursor: 'pointer',
                    '&:hover': {
                      backgroundColor: 'rgba(0, 0, 0, 0.04)'
                    }
                  }}
                >
                  <ListItemText 
                    primary={<span style={{ fontWeight: 600, color: '#222' }}>{section.title}</span>} 
                  />
                  <FontAwesomeIcon icon={openDropdowns[section.id] ? faMinus : faPlus} />
                </ListItem>
                <Collapse in={openDropdowns[section.id]} timeout="auto" unmountOnExit>
                  <List disablePadding>
                    {section.items.map((item) => (
                      <ListItemButton
                        key={item.name}
                        sx={{
                          pl: 4, 
                          py: 0.5,
                          cursor: 'pointer',
                          '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.04)'
                          }
                        }}
                        onClick={() => {
                          setMenuModalOpen(false);
                          if (item.path) {
                            navigate(item.path);
                          }
                        }}
                      >
                        <ListItemText
                          primary={item.name}
                          primaryTypographyProps={{ fontSize: 14 }}
                        />
                      </ListItemButton>
                    ))}
                  </List>
                </Collapse>
                <Divider />
              </>
            )}
          </div>
        ))}
      </List>

      {/* Contact Number */}
      <Button fullWidth variant="text" sx={{ color: '#d10000', fontWeight: 600, mb: 2, justifyContent: 'flex-start', pl: 1 }} startIcon={<FontAwesomeIcon icon={faPhone} />}>
        {modalData.contact.phone}
      </Button>

      {/* Social Icons */}
      <Box sx={{ mt: 'auto', mb: 4, display: 'flex', gap: 2, alignItems: 'center', pl: 1 }}>
        {modalData.socialIcons.map((icon) => (
          <IconButton key={icon.name} size="small">
            <FontAwesomeIcon icon={icon.component} style={{ color: '#a6a6a6' }} />
          </IconButton>
        ))}
      </Box>
    </Box>
  );


  return (
    <Box>
      <Drawer anchor="left" open={menuModalOpen} onClose={handleMenuModalToggle} sx={{
        '& .MuiDrawer-paper': {
          width: 350,
          boxSizing: 'border-box',
          overflowY: 'auto',
          msOverflowStyle: 'none',
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': {
            display: 'none',
          },
        },
      }}
      >
        {menuDrawer}
      </Drawer>
      <Drawer anchor="right" open={rightDrawerOpen} onClose={toggleRightDrawer(false)}>{rightDrawer}</Drawer>
      {/* Navbar */}
      <AppBar
        position="fixed"
        sx={{
          top: 0, left: 0, right: 0,
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.3)',
          backgroundColor: 'transparent', bgcolor: 'white',
          zIndex: 900, transition: 'all 0.3s ease',
        }}
        elevation={0}
      >
        <Container maxWidth="xl" sx={{  backgroundColor: 'white' }}>
          <Box
            sx={{
              backgroundColor: 'white',
              py: 1,
              borderRadius: '0',
              height: '80px',
              minHeight: { xs: '80px', md: '80px' },
              width: '100%',
              transition: 'all 0.3s ease',
            }}
          >
            <Toolbar
              sx={{
                minHeight: { xs: '80px', md: '80px' },
                transition: 'all 0.3s ease',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                p: 0,
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <IconButton
                  onClick={handleMenuModalToggle}
                  sx={{
                    p: 0,
                    '&:hover': {
                      backgroundColor: 'transparent',
                    },
                  }}
                >
                  <img loading='lazy' src={hamburgerlogo} alt="Menu" style={{ height: '18px', cursor: 'pointer' }} />
                </IconButton>
                <img loading='lazy' src={logo} onClick={() => navigate('/')} alt="Logo" style={{ height: '40px', cursor: 'pointer' }} />
              </Box>

              {/* Right side hamburger menu for mobile */}
              {isMobile && (
                <IconButton
                  onClick={toggleRightDrawer(true)}
                  sx={{
                    ml: 'auto',
                    color: '#333',
                    '&:hover': {
                      backgroundColor: 'transparent',
                    },
                  }}
                >
                  <FontAwesomeIcon icon={faBars} style={{ fontSize: '24px' }} />
                </IconButton>
              )}
              <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 3 }}>
                {navItems.map((item) => (
                  <Button
                    disableElevation
                    disableRipple
                    disableFocusRipple

                    key={item.text}
                    onClick={() => navigate(item.path)}
                    sx={{
                      color: '#333',
                      textTransform: 'none',
                      fontWeight: 600,
                      fontSize: { xs: '14px', md: '16px' },
                      minWidth: 'auto',
                      px: { xs: 1, md: 2 },
                      '&:hover': {
                        color: '#d10000',
                        backgroundColor: 'transparent',
                        boxShadow: 'none',

                      },
                    }}
                  >
                    <FontAwesomeIcon
                      icon={item.icon}
                      style={{
                        marginRight: '8px',
                        fontSize: '15px',
                      }}
                    />
                    <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' } }}>
                      {item.text}
                    </Box>
                  </Button>
                ))}
              </Box>
            </Toolbar>
          </Box>
        </Container>
      </AppBar>
    </Box>
  );
}; 

export default Navbar;
